import { int16, int32, int8, uint16, uint32, uint8 } from '../../utils';
import dataItemStyle from '../dataItemStyle';
import {
  ANIMATION,
  CONDITION,
  DATA,
  FILE,
  FONT_ID,
  FONT_Weight,
  IMG,
  IMG_ARRAY,
  LAYOUT,
  SLOT,
  SPRITE,
  TRANSLATION,
  WIDGET
} from '../dataSource';
import { genAnimationBin } from './genAnimationBin';
import { genConditionBin } from './genConditionBin';
import { genSlotBin } from './genSlotBin';
import { genWidgetBin } from './genWidgetBin';

export function genDataBinary(data: any[]): Buffer[] {
  const dataBin: Buffer[] = [];
  let currentLength = 0;
  data.forEach((item: any) => {
    const prevBinCount = dataBin.length;
    console.log(item.type, item.name ?? item.fileName ?? '', currentLength);
    const { type, recolorEnable } = item;
    switch (type) {
      case FILE:
        {
          // 经与固件wangxuedong确认，使用filename即可
          const { fileName } = item;
          const file_DataLength_NameLength = uint32(
            item.dataLength + (fileName.length << 24)
          );
          const file_Reserved = Buffer.alloc(16);
          const nameBuf = Buffer.alloc(fileName.length);
          nameBuf.write(fileName);
          const data = item.jsBuffer;
          const JSFileBin = Buffer.concat([
            file_DataLength_NameLength,
            file_Reserved,
            nameBuf,
            data
          ]);
          dataBin.push(JSFileBin);
          // 释放原始 jsBuffer 引用，允许 GC 回收（大量 LUA/JS bin 文件时可节省数百 MB 内存）
          item.jsBuffer = null;
        }
        break;
      case IMG:
        {
          const imgBin = Buffer.concat([
            uint8(item.fmtIndex === undefined ? 0 : item.fmtIndex), // fmt
            uint8(
              (item.compressIndex << 2) + (recolorEnable === 'true' ? 1 : 0)
            ), // 是否压缩
            uint16(0), // reserved
            uint16(item.width),
            uint16(item.height),
            uint32(item.dataLength),
            item.imgData
          ]);
          dataBin.push(imgBin);
        }
        break;
      case LAYOUT:
        {
          const resRecordUid = item.resUid;
          const defaultIndex = Number(item.defaultIndex || 0);
          console.log(`[BIN] Layout parameter: x=${item.x}, y=${item.y}, defaultIndex=${item.defaultIndex}, resolved=${defaultIndex}`);
          const layoutBin = Buffer.concat([
            resRecordUid,
            int16(item.x || 0),
            int16(item.y || 0),
            uint32(defaultIndex), //parameter: bit[7:0]为默认展示项index，bit[31:8] reserved
            uint32(0) //reserved
          ]);
          dataBin.push(layoutBin);
        }
        break;
      case IMG_ARRAY:
        {
          const fmt = uint8(item.fmtIndex === undefined ? 0 : item.fmtIndex);
          const imgNumber = uint8(item.imgNumber);
          const flag = uint16(
            (item.compressIndex << 2) + (recolorEnable === 'true' ? 1 : 0)
          );
          const imgWidth = uint16(item.width);
          const imgHeight = uint16(item.height);
          let imgInfo = Buffer.concat([]);
          const imgData = item.imgData.length
            ? item.imgData
            : Buffer.from(item.imgData);
          const imgLengthInfo = item.imgLengthInfo as number[];
          if (imgLengthInfo && (item.compressIndex || item.isN65AB)) {
            //当存在包含图片长度的数组并且 有压缩方式并且压缩方式不等于None，就去计算imgInfo的长度
            imgLengthInfo.forEach((len) => {
              imgInfo = Buffer.concat([imgInfo, uint32(len)]);
            });
          }
          const dataLength = uint32(item.dataLength);
          const imgArrBin = Buffer.concat([
            fmt,
            imgNumber,
            flag,
            imgWidth,
            imgHeight,
            dataLength,
            imgInfo,
            imgData
          ]);
          dataBin.push(imgArrBin);
        }
        break;
      case TRANSLATION:
        dataBin.push(item.translationData);
        break;
      case SPRITE: {
        let refUID;
        const { isVideo, isMultiSprite } = item;
        if (isMultiSprite) {
          const count = uint8(item.count);
          const flags = uint8(1);
          const interval = uint16(item.interval);
          const repeatCount = uint32(item.repeatCount);
          let _sprite_info: Buffer = Buffer.alloc(0);
          item.spriteInfoData.map((child: any) => {
            _sprite_info = Buffer.concat([
              _sprite_info,
              child.uid_img_array,
              uint8(child.default_index),
              uint8(0), // 去掉video_index
              uint16(0)
            ]);
          });

          const MultiSpriteBin = Buffer.concat([
            count,
            flags,
            interval,
            repeatCount,
            _sprite_info
          ]);
          dataBin.push(MultiSpriteBin);
        } else {
          if (isVideo) refUID = item.uidVideoFile;
          else refUID = item.uidImgArray;
          const imgNum = isVideo ? uint8(0) : uint8(item.imgNum);
          // flags=1表示复杂动画，目前不支持复杂动画
          const flags = uint8(0);
          const interval = isVideo ? uint16(0) : uint16(item.interval);
          const repeatCount = uint32(item.repeatCount);

          const spriteOrVideoBin = Buffer.concat([
            refUID,
            imgNum,
            flags,
            interval,
            repeatCount
          ]);
          dataBin.push(spriteOrVideoBin);
        }
        break;
      }
      case CONDITION: {
        dataBin.push(genConditionBin(item));
        break;
      }
      case ANIMATION: {
        dataBin.push(genAnimationBin(item));
        break;
      }
      case DATA:
        {
          const { tag } = item;

          switch (tag) {
            case 'DataItemText': {
              //文本转bin

              const {
                translationUid,
                literalUid,
                style,
                align,
                contents,
                verticalAlign,
                literal_num,
                string,
                longMode
              } = item;
              // todo 透明度更改
              if (item._opacity === undefined) {
                item._opacity = 100;
              }
              const alpha = Math.round(2.55 * (100 - Number(item._opacity)));
              const color = uint32(
                parseInt(
                  item.color.replace(new RegExp('#', 'g'), alpha.toString(16)),
                  16
                )
              );

              const fontSize = parseInt(item.fontSize);

              let fontId = 0;
              if (item.fontId) {
                fontId = FONT_ID[item.fontId]; //字体枚举
              }
              let fontWeight = 0;
              if (item.fontWeight) {
                fontWeight = FONT_Weight[item.fontWeight];
              }
              let letterSpace = 0;

              let alignFlag = 0;
              if (align === 'center') {
                alignFlag = 1;
              } else if (align === 'right') {
                alignFlag = 2;
              }
              const longModeIndex =
                longMode === 'wrap'
                  ? 0
                  : longMode === 'scroll'
                  ? 2
                  : longMode === 'scroll_circular'
                  ? 3
                  : longMode === 'clip'
                  ? 4
                  : 1;

              const styleBuffer =
                style === 'normal' || style == undefined || style == '' ? 0 : 1;

              letterSpace = Number(item.letterSpace); //字符间距

              const hasTranslation = translationUid ? 1 : 0; //翻译
              const hasLiteral = literal_num ? 1 : 0; //文字表盘
              const has_ext_font_size = fontSize > 255 ? 1 : 0;
              const idsFormer26Bits =
                (has_ext_font_size ? 0 : fontSize) +
                (fontId << 8) +
                (fontWeight << 14) +
                ((letterSpace << 18) >>> 0);
              const binaryUid = idsFormer26Bits.toString(2).padStart(32, '0');
              let res = '';
              const former8BitsZero = (0x3ffffff).toString(2).padStart(32, '0');
              for (let i = 0; i < 32; i++) {
                const cur = Number(binaryUid[i]) & Number(former8BitsZero[i]);
                res += cur;
              }
              const ids = uint32(
                parseInt(res, 2) +
                  (hasTranslation << 26) +
                  (hasLiteral << 27) +
                  (has_ext_font_size << 28)
              );
              const mode = uint32(
                alignFlag + (longModeIndex << 3) + (styleBuffer << 6)
              );
              let textBuffer = Buffer.alloc(0);
              if (styleBuffer == 0) {
                let space = item.lineSpace;
                const swap = Buffer.alloc(1);
                swap.writeInt8(space);
                space = swap.readUInt8();
                const width = parseInt(item.w);
                const height = parseInt(item.h);
                const rotation = item.rotation;

                const styles = space + (width << 8) + (height << 18);

                const bufferabc = uint32(styles);
                const rotationBuffer = int16(rotation * 10);
                const reserved = uint16(0);
                textBuffer = Buffer.concat([
                  bufferabc,
                  rotationBuffer,
                  reserved
                ]);
              } else {
                const radius = parseInt(item.radius);
                const verticalAlignFlag =
                  verticalAlign === 'top' || verticalAlign == undefined
                    ? 0
                    : verticalAlign === 'center'
                    ? 1
                    : 2;
                const startAngle = parseInt(item.startAngle) * 10;
                const span = parseInt(item.span) * 10;
                const rBUffer = uint32(radius + (verticalAlignFlag << 10));
                const startAngleBuf = int16(startAngle);
                const spanBuf = int16(span);
                textBuffer = Buffer.concat([rBUffer, startAngleBuf, spanBuf]);
              }
              let literalBuffer = Buffer.alloc(0);
              if (literal_num) {
                let literalInfo: Buffer;
                if (has_ext_font_size)
                  literalInfo = uint32(Number(literal_num) + (fontSize << 8));
                else
                  literalInfo = Buffer.concat([
                    uint8(literal_num),
                    uint16(0),
                    uint8(0)
                  ]);
                literalBuffer = Buffer.concat([
                  literalUid ? literalUid : uint32(0),
                  literalInfo
                ]);
              } else literalBuffer = Buffer.concat([uint32(0), uint32(0)]);
              const reservedBuf = Buffer.alloc(8);
              let nameBuf;
              if (hasTranslation) {
                nameBuf = Buffer.from(string);
              } else nameBuf = Buffer.from(string);
              let strLen = nameBuf.length;
              if (translationUid) {
                nameBuf = translationUid;
                strLen = 0;
              }
              // const contents = item._content.split('-');
              const dataCount = contents.length;
              const strId = strLen + (dataCount << 8);

              const strBuf = uint32(strId);

              let sourIdBuf = Buffer.alloc(0);

              for (let i = 0; i < contents.length; i++) {
                sourIdBuf = Buffer.concat([
                  sourIdBuf,
                  uint16(dataItemStyle[contents[i]])
                ]);
              }
              const DataItemTextBinary = Buffer.concat([
                uint16(0), //source_id
                uint8(0), // digits
                uint8(0b00000000), //private

                uint16(recolorEnable === 'true' ? 1 : 0), // reserved, bit0=recolorEnable
                uint16(Number(item.parameter ?? 0))
              ]);

              const allBuf = Buffer.concat([
                DataItemTextBinary,
                color,
                ids,
                mode,
                textBuffer,
                literalBuffer,
                reservedBuf,
                strBuf,
                nameBuf,
                sourIdBuf
              ]);
              dataBin.push(allBuf);
              break;
            }
            case 'DataItemImageValues': {
              const imgValuesSourceId = uint16(dataItemStyle[item.source]);
              const imgValuesDigits = uint8(0);
              const imgValuesFlags = uint8((2 << 4) + 0);
              const imgValuesPrivate = uint16(0);
              const imgNumparameter = uint16(Number(item.parameter ?? 0));
              const imgValuesRecordBinary = Buffer.concat([
                imgValuesSourceId,
                imgValuesDigits,
                imgValuesFlags,
                imgValuesPrivate,
                imgNumparameter
              ]);

              const imgValuesImgArrUid = Buffer.from(
                JSON.parse(JSON.stringify(item.uidImgArray))
              );
              const imgValuesReserved = uint8(0);
              const tableFlags = uint8(item.flags);
              const imgValuesRotation = int16(item.rotation);
              const dataTable = item.dataTable;
              const imgValuesDataStyleBinary = Buffer.concat([
                imgValuesImgArrUid,
                imgValuesReserved,
                tableFlags,
                imgValuesRotation,
                dataTable
              ]);

              const imgValuesDataBinary = Buffer.concat([
                imgValuesRecordBinary,
                imgValuesDataStyleBinary
              ]);
              dataBin.push(imgValuesDataBinary);
              break;
            }

            case 'DataItemImageNumber': {
              const { align } = item;
              const imgNumSourceId = uint16(dataItemStyle[item.source]);
              // digits中 3:0总位数 7:4小数位数
              const imgNumDigits = uint8(
                (Number(item.decimalDigits) << 4) + Number(item.totalDigits)
              );
              // 1:0 00右 01左 10中
              let alignFlag = 0;
              if (align === 'right') {
                alignFlag = 0;
              } else if (align === 'left') {
                alignFlag = 1;
              } else if (align === 'center') {
                alignFlag = 2;
              }
              const leadingZeroFlag = item.leadingZero === 'true' ? 1 : 0;
              const trailingZeroFlag = item.trailingZero === 'true' ? 1 : 0;
              const imgNumFlags = uint8(
                (1 << 4) +
                  (trailingZeroFlag << 3) +
                  (leadingZeroFlag << 2) +
                  alignFlag
              );
              let renderRule = 0;
              if (item.renderRule === 'alwaysShow') {
                renderRule = 0;
              } else if (item.renderRule === 'hideWhenUnitMismatch') {
                renderRule = 1;
              }
              const imgNumflags1 = uint16(0 + (renderRule << 1));
              const imgNumparameter = uint16(Number(item.parameter ?? 0));
              const imgNumRecordBinary = Buffer.concat([
                imgNumSourceId,
                imgNumDigits,
                imgNumFlags,
                imgNumflags1,
                imgNumparameter
              ]);

              const imgNumImgArrUid = JSON.parse(
                JSON.stringify(item.uidImgArray)
              );
              const imgNumDecimal_offset_x = int8(item.decimalOffsetX);
              const space = int8(item.space);
              const imgNumRotation = int16(item.rotation * 10);
              const uidUnitIcon = item.unitIcon ? item.unitIcon : uint32(0);
              const imgNumDataStyleBinary = Buffer.concat([
                Buffer.from(imgNumImgArrUid),
                imgNumDecimal_offset_x,
                space,
                imgNumRotation,
                uidUnitIcon
              ]);

              const imgNumDataBinary = Buffer.concat([
                imgNumRecordBinary,
                imgNumDataStyleBinary
              ]);
              dataBin.push(imgNumDataBinary);
              break;
            }
            case 'DataItemPointer': {
              let renderRule = 0;
              if (item.renderRule === 'alwaysShow') {
                renderRule = 0;
              } else if (item.renderRule === 'hideWhenUnitMismatch') {
                renderRule = 1;
              } else if (item.renderRule === 'hideWhenOutRange') {
                renderRule = 2;
              }
              const renderRuleBuffer = uint16(0 + (renderRule << 1));
              const dataRecordBinary = Buffer.concat([
                uint16(dataItemStyle[item.source]),
                uint8(0), // digits
                uint8(0b00110000), //private
                renderRuleBuffer,
                uint16(Number(item.parameter ?? 1000))
              ]);

              // 判断是否为数据源引用：必须是非空字符串且不可解析为数字
              // null/undefined/空串/"0"等都不是数据源引用，只有"healthHeartRateMin"这类字符串才是
              const isValueStartRef =
                typeof item.valueStart === 'string' &&
                item.valueStart !== '' &&
                isNaN(Number(item.valueStart));
              const isValueRangeRef =
                typeof item.valueRange === 'string' &&
                item.valueRange !== '' &&
                isNaN(Number(item.valueRange));

              const valueStartB = isValueStartRef
                ? int32(dataItemStyle[item.valueStart])
                : int32((Number(item.valueStart) || 0) * 256);
              const valueRangeB = isValueRangeRef
                ? int32(dataItemStyle[item.valueRange])
                : int32((Number(item.valueRange) || 0) * 256);
              const centorXB = int16(item.pivotX);
              const centorYB = int16(item.pivotY);
              const angleStartB = int16(item.angleStart * 10);
              const angleRangeB = int16(item.angleRange * 10);
              const pointerValueStartFlag = isValueStartRef ? 1 : 0;
              const pointerValueRangeFlag = isValueRangeRef ? 1 : 0;
              const pointerFlag = uint32(
                (pointerValueRangeFlag << 3) + (pointerValueStartFlag << 2)
              );
              const dataStyleBinary = Buffer.concat([
                item.pointerRefImg,
                valueStartB,
                valueRangeB,
                centorXB,
                centorYB,
                angleStartB,
                angleRangeB,
                pointerFlag
              ]);

              const dataBinary = Buffer.concat([
                dataRecordBinary,
                dataStyleBinary
              ]);
              dataBin.push(dataBinary);
              break;
            }
            case 'DataItemArcProgressBar': {
              const arcSourceId = uint16(dataItemStyle[item.source]);
              const arcDigits = uint8(0);
              const arcFlags = uint8((4 << 4) + 0);

              let renderRuleArc = 0;
              if (item.renderRuleArc === 'alwaysShow') {
                renderRuleArc = 0;
              } else if (item.renderRuleArc === 'hideWhenUnitMismatch') {
                renderRuleArc = 1;
              }
              const arcFlags1 = uint16(0 + (renderRuleArc << 1));
              const arcParameter = uint16(item.parameter ?? 0);
              const arcRecordBinary = Buffer.concat([
                arcSourceId,
                arcDigits,
                arcFlags,
                arcFlags1,
                arcParameter
              ]);

              const fgImgUid = item.uidFgImg;
              const bgImgUid = item.uidBgImg ? item.uidBgImg : uint32(0);
              const arcLineCapFlag = item.endingStyle === 'round' ? 1 : 0;
              const arcPointerFlag = item.uidIndicatorImg ? 1 : 0;

              const arcValueStartFlag =
                typeof item.valueStart === 'string' &&
                item.valueStart !== '' &&
                isNaN(Number(item.valueStart))
                  ? 1
                  : 0;
              const arcValueRangeFlag =
                typeof item.valueRange === 'string' &&
                item.valueRange !== '' &&
                isNaN(Number(item.valueRange))
                  ? 1
                  : 0;
              const arcStyleFlags = uint32(
                (arcValueRangeFlag << 3) +
                  (arcValueStartFlag << 2) +
                  (arcPointerFlag << 1) +
                  arcLineCapFlag
              );

              const arcValueStart = arcValueStartFlag
                ? int32(dataItemStyle[item.valueStart])
                : int32((Number(item.valueStart) || 0) * 256);
              const arcValueRange = arcValueRangeFlag
                ? int32(dataItemStyle[item.valueRange])
                : int32((Number(item.valueRange) || 0) * 256);
              const arcCentorX = int16(item.pivotX);
              const arcCentorY = int16(item.pivotY);
              const arcAngleStart = int16(item.angleStart * 10);
              const arcAngleRange = int16(item.angleRange * 10);
              const arcBarRadius = int16(item.barRadius);
              const arcBarWidth = int16(item.barWidth);

              const indicator = [];
              // 是否有indicator，指示器结构都要存在，无则数据置0
              const arcIndicatorImgUid = arcPointerFlag
                ? item.uidIndicatorImg
                : uint32(0);
              const arcIndicatorRadius = arcPointerFlag
                ? int16(item.indicatorRadius)
                : int16(0);
              const reserved1 = int16(0);
              const reserved2 = uint32(0);
              indicator.push(
                arcIndicatorImgUid,
                arcIndicatorRadius,
                reserved1,
                reserved2
              );
              const indicatorBinary = Buffer.concat(indicator);
              const arcDataStyleBinary = Buffer.concat([
                fgImgUid,
                bgImgUid,
                arcStyleFlags,
                arcValueStart,
                arcValueRange,
                arcCentorX,
                arcCentorY,
                arcAngleStart,
                arcAngleRange,
                arcBarRadius,
                arcBarWidth,
                item.uidIndicatorImg ? indicatorBinary : Buffer.alloc(0)
              ]);
              const arcDataBinary = Buffer.concat([
                arcRecordBinary,
                arcDataStyleBinary
              ]);
              dataBin.push(arcDataBinary);
              break;
            }
            case 'DataItemLineProgressBar': {
              const lineSourceId = uint16(dataItemStyle[item.source]);
              const lineDigits = uint8(0);
              const lineFlags = uint8((5 << 4) + 0);

              let renderRuleLine = 0;
              if (item.renderRuleLine === 'alwaysShow') {
                renderRuleLine = 0;
              } else if (item.renderRuleLine === 'hideWhenUnitMismatch') {
                renderRuleLine = 1;
              }
              const lineFlags1 = uint16(0 + (renderRuleLine << 1));
              const lineParameter = uint16(item.parameter ?? 0);
              const lineRecordBinary = Buffer.concat([
                lineSourceId,
                lineDigits,
                lineFlags,
                lineFlags1,
                lineParameter
              ]);
              const linefgImgUid = item.uidFgImg;
              const lineBgImgUid = item.uidBgImg ? item.uidBgImg : uint32(0);
              const lineLineCapFlag = item.endingStyle === 'round' ? 1 : 0;
              const linePointerFlag = item.indicatorRelateUid ? 1 : 0;

              const lineValueStartFlag =
                typeof item.valueStart === 'string' &&
                item.valueStart !== '' &&
                isNaN(Number(item.valueStart))
                  ? 1
                  : 0;
              const lineValueRangeFlag =
                typeof item.valueRange === 'string' &&
                item.valueRange !== '' &&
                isNaN(Number(item.valueRange))
                  ? 1
                  : 0;
              const lineStyleFlags = uint32(
                (lineValueRangeFlag << 3) +
                  (lineValueStartFlag << 2) +
                  (linePointerFlag << 1) +
                  lineLineCapFlag
              );

              const lineValueStart = lineValueStartFlag
                ? int32(dataItemStyle[item.valueStart])
                : int32((Number(item.valueStart) || 0) * 256);
              const lineValueRange = lineValueRangeFlag
                ? int32(dataItemStyle[item.valueRange])
                : int32((Number(item.valueRange) || 0) * 256);
              const lineStartX = int16(item.startX);
              const lineStartY = int16(item.startY);
              const lineEndX = int16(item.endX);
              const lineEndY = int16(item.endY);
              const lineReserved = uint16(0);
              const lineBarWidth = uint16(item.barWidth);

              const lineIndicator = [];
              const lineIndicatorImgUid = linePointerFlag
                ? item.indicatorRelateUid
                : uint32(0);
              const lineOffsetX = linePointerFlag
                ? int16(item.indicatorOffsetX)
                : int16(0);
              const lineOffsetY = linePointerFlag
                ? int16(item.indicatorOffsetY)
                : int16(0);
              const lineReserved2 = uint32(0);
              lineIndicator.push(
                lineIndicatorImgUid,
                lineOffsetX,
                lineOffsetY,
                lineReserved2
              );
              const lineIndicatorBinary = Buffer.concat(lineIndicator);
              const lineDataStyleBinary = Buffer.concat([
                linefgImgUid,
                lineBgImgUid,
                lineStyleFlags,
                lineValueStart,
                lineValueRange,
                lineStartX,
                lineStartY,
                lineEndX,
                lineEndY,
                lineReserved,
                lineBarWidth,
                item.indicatorRelateUid ? lineIndicatorBinary : Buffer.alloc(0)
              ]);
              const lineDataBinary = Buffer.concat([
                lineRecordBinary,
                lineDataStyleBinary
              ]);
              dataBin.push(lineDataBinary);
              break;
            }
            default:
              break;
          }
        }
        break;
      case WIDGET: {
        dataBin.push(genWidgetBin(item));
        break;
      }
      case SLOT: {
        dataBin.push(genSlotBin(item));
        break;
      }
      default:
        break;
    }
    // 用前后 dataBin 长度差追踪新增数据大小
    const newBufs = dataBin.slice(prevBinCount);
    for (const buf of newBufs) currentLength += buf.length;
  });
  return dataBin;
}
